import { apiRequest, ResultAPI } from 'app/requests/apiRequest';
import { buildParams } from 'app/utils/pagination';

export const list = async (params) => {
    const path = `/api/topics${buildParams(params)}`;
    const topics = await apiRequest(path, 'get') as ResultAPI;
    return topics?.data;
};

export const getBySlug = async (params) => {
    const path = `/api/topics/slug/${params.category}${buildParams(params)}`;
    const topics = await apiRequest(path, 'get') as ResultAPI;
    return topics?.data;
};

export const getNewSlug = async (params) => {
  try {
    const paramsUrl = buildParams(params);
    const result = await apiRequest(`/api/topics/new_slug/${params.slug}${paramsUrl}`, 'get') as ResultAPI;
    return result.data;
  } catch (error) {
    console.error(error?.message);
  }
};
